import { useStore } from '@/stores/main';

export default async (to: any) => {
  const store = useStore();

  if (!store.loggedIn) {
    store.logout();
    return { path: '/login' };
  }

  if (store.onboarding.status !== 'complete') {
    return { path: '/complete-registration' };
  }

  await store.reconcileCurrentProfile();

  // Completed plans are read-only; questionnaire answers need an active plan.
  if (/^\/questions\/[12]\/?$/.test(to.path) && !store.profile?.id) {
    return { path: '/home', replace: true };
  }

  store.recordQuestionFlowRoute(to.fullPath || to.path);

  // TEMPORARILY DISABLED - Session validation
  // // Check if session is expired
  // if (store.isSessionExpired()) {
  //   store.logout();
  //   return { path: '/login' };
  // }

  // // For critical routes, validate with backend
  // const criticalRoutes = ['/home', '/plan', '/goals', '/overview'];
  // if (criticalRoutes.includes(to.path)) {
  //   const isValid = await store.validateSession();
  //   if (!isValid) {
  //     store.logout();
  //     return { path: '/login' };
  //   }
  // }

  return true;
};
